/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { qreq } from "../../../shared/qrequest";
import BaseCom from "../../BaseCom";
import FormInput from "../../FormInput";
import L from "../../Lang";
import Totals from "../Totals";


export default class CreditCard extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            info: {
                processType: 'cc',
                cardHolderName: '',
                cardNumber: '',
                cardExpiry: '',
                cardCvv: ''
            }
        }
    }


    async componentDidMount() {
        await this.getSettings();
        let jwt = await this.fetchJWT();
        this.pollCardinal(jwt, this.state.info.cardNumber);
        this.setState({ info: { ...this.state.info, cardHolderName: this.props.session.firstName + ' ' + this.props.session.lastName } });
    }

    setCardinalSessionID = (sessionID) => {
        console.log('Cardinal Session ID:', sessionID);
        this.setState({ cardinalSessionID: sessionID });
    }

    fetchJWT = async () => {
        try {
            let j = await qreq.getAsync('/api/payment/jwt');
            if (j.item) {
                this.setState({ jwt: j.item, info: { ...this.state.info, jwt: j.item } });
                this.pollCardinal(j.item, this.state.info.cardNumber);
                return j.item;
            }
            else
                this.props.onError(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    submit = async (e, sessionID) => {
        if (!sessionID) sessionID = this.state.cardinalSessionID;
        e?.preventDefault();
        this.setState({ submitting: true });
        try {
            let info = { ...this.state.info };
            info.amount = this.props.session.amount;
            info.sessionID = sessionID;
            info.sid = this.props.session.sid;
            info.jwt = this.state.jwt;
            if (!info.sessionID) {
                this.alert('Session has expired. Will reload payment process.');
                window.location.reload();
                return;
            }
            let j = await qreq.postAsync('/api/payment/process', info);
            if (j.item)
                this.props.onSuccess(j.item);
            else
                this.props.onError(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
        this.setState({ submitting: false });
    }

    change = () => {
        this.setState({ info: { ...this.state.info } });
    }

    setupCardinalCallbacks = () => {
        if (!window.Cardinal)
            return;
        var _self = this;

        window.Cardinal.on("payments.setupComplete", function (setupCompleteData) {
            console.log('setupCompleteData', setupCompleteData);
            _self.setCardinalSessionID(setupCompleteData.sessionId);
        });

        window.Cardinal.on('payments.validated', function (decodedResponseData, responseJWT) {
            console.log('payments.validated', decodedResponseData, responseJWT);
        });
    }

    pollCardinal = (jwt, cardNumber) => {
        if (!cardNumber)
            return;
        cardNumber = cardNumber.replace(/[^0-9]/g, '');
        if (cardNumber.length < 14)
            return;
        if (this.state.cardinalInitialized) {
            window.Cardinal.trigger('order.update', {
                Consumer: {
                    Account: {
                        AccountNumber: cardNumber
                    }
                }
            });
            return;
        }

        window.Cardinal.configure({
            logging: {
                debug: 'verbose'
            },
        });

        window.Cardinal.setup("init", {
            jwt: jwt,
            order: {
                Consumer: {
                    Account: {
                        AccountNumber: cardNumber
                    }
                }
            }
        });

        this.setupCardinalCallbacks();

        this.setState({ cardinalInitialized: true });
    }

    cardChange = (v) => {
        this.pollCardinal(this.state.jwt, v);
        this.change();
    }

    render() {
        return <form onSubmit={this.submit}>
            <div className="row">
                <div className="col-md-12">
                    <h2>Credit Card</h2>
                    <FormInput model={this.state.info} name="cardHolderName" label="Name on card" onChange={this.change} placeholder="Your Name" required />
                    <FormInput model={this.state.info}
                        name="cardNumber"
                        label="Card Number"
                        onChange={this.cardChange}
                        placeholder="•••• •••• •••• ••••"
                        required
                    />
                    <div className="row">
                        <div className="col-sm-8">
                            <FormInput model={this.state.info} name="cardExpiry" label="Expires" mask="##/##" placeholder="MM/YY" required />
                        </div>
                        <div className="col-sm-4">
                            <FormInput model={this.state.info} name="cardCvv" label="CVC" placeholder="123" required />
                        </div>
                    </div>
                </div>
            </div>
            <Totals session={this.props.session} />
            <div className="d-grid my-2">
                <button type="submit" className="btn btn-primary btn-lg" disabled={this.state.submitting || !this.state.cardinalSessionID}>
                    {this.state.submitting ? <L>Processing please wait...</L>
                        : <L>Complete Payment</L>}
                </button>
                {!this.state.submitting && <button type="button" className="btn btn-lg" onClick={this.props.onCancel}>
                    <L>Select a different Payment Method</L>
                </button>}
            </div>
        </form>;
    }
}